
import NewSkeletonBox from '~/components/common/loading/skeleton/NewSkeletonBox.vue'
import PaginationSkeleton from '~/components/common/loading/skeleton/PaginationSkeleton.vue'
import ProductGridSkeleton from '~/components/common/loading/skeleton/ProductGridSkeleton.vue'

export default {
  name: 'StoreHomeSkeleton',
  components: {
    ProductGridSkeleton,
    NewSkeletonBox,
    PaginationSkeleton
  },
  data () {
    return {
      bannerSlideCount: 3,
      categoryChipCount: 14,
      tabCount: 3,
      chipCount: 4,
      productCardCount: 6
    }
  }
}
